import { format, parseISO, isValid } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return "N/A";
  const parsed = parseISO(dateString);
  return isValid(parsed) ? format(parsed, "MMM d, yyyy h:mm a") : "N/A";
};
export const formatDateUTC = (
  dateString: string | null | undefined
): string => {
  if (!dateString) return "N/A";
  const parsed = parseISO(dateString);
  return isValid(parsed)
    ? formatInTimeZone(parsed, "UTC", "MMM d, yyyy h:mm a 'UTC'")
    : "N/A";
};

export const formatDateIST = (
  dateString: string | null | undefined
): string => {
  if (!dateString) return "N/A";
  const parsed = parseISO(dateString);
  return isValid(parsed)
    ? formatInTimeZone(parsed, "Asia/Kolkata", "MMM d, yyyy h:mm a 'IST'")
    : "N/A";
};
